// extracted by mini-css-extract-plugin
export default {"header":"Header-module--header--1b4d8","headerMiddleText":"Header-module--header-middle-text--59792"};